import React from 'react';
import { Box } from '@mui/material';
import { AmbientPreset, ambientBackground, GRAIN_URL } from '../../constants/profileAmbient';

/**
 * ページ全体の環境光。コンテンツより後ろに固定で敷く。
 *
 * **静止させておくこと。** 動かさなければ初回のラスタライズ1回で終わり、
 * 以降のコストはゼロ。ビューポート固定なのでスクロールしても再描画されない。
 *
 * z-index を負にしているのは、プロフィールページの各要素に
 * position/z-index を足して回らずに背面へ送るため。
 * body の背景（CssBaseline の background.default）はこれより後ろに描かれる。
 */
const AmbientBackground: React.FC<{ preset: AmbientPreset; accent: string }> = ({
  preset,
  accent,
}) => (
  <Box
    aria-hidden
    sx={{
      position: 'fixed',
      inset: 0,
      zIndex: -1,
      pointerEvents: 'none',
      background: ambientBackground(preset, accent),
    }}
  >
    {/* グレイン。これが無いと暗い地では必ず帯が出る */}
    <Box
      sx={{
        position: 'absolute',
        inset: 0,
        backgroundImage: GRAIN_URL,
        backgroundSize: '300px 300px',
        opacity: preset.grain,
      }}
    />
  </Box>
);

export default AmbientBackground;
